import { createTheme as createMuiTheme } from '@mui/material'

// import { createPalette } from "./create-palette";
// import { createShadows } from "./create-shadows";
// import { createComponents } from "./create-components";
import { createTypography } from './create-typography'

export const createTheme = () => {
  // const palette = createPalette();
  // const shadows = createShadows();
  const typography = createTypography()
  // const components = createComponents({ palette });

  return createMuiTheme({
    // palette,
    // shadows,
    // components,
    typography,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440
      }
    },
    shape: {
      borderRadius: 8
    }
  })
}
